import { string } from 'yup';
import { P as PASSWORD_REQUIRED_MESSAGE, f as MIN_CHARACTERS_MESSAGE, g as MAX_CHARACTERS_MESSAGE, c as INCORRECT_PASSWORD_MESSAGE } from '../validation-g1IuPS7K.js';

// Required: at least one uppercase, one lowerCase, one number
// Optional: any special symbol(s)
const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(\S)+$/;
// Letters (including ñ and vowels with accent marks), apostrophe, space and hyphen
// Supports: Em dash "—", En Dash "–" and hyphen "-"
// https://www.merriam-webster.com/grammar/em-dash-en-dash-how-to-use
const nameRegex = /^([A-Za-zÀ-ú-–— ñÑ]+)$/g;
// Contains at least one number
const addressRegex = /\d/;
const password = string()
    .trim()
    .required(PASSWORD_REQUIRED_MESSAGE)
    .min(8, MIN_CHARACTERS_MESSAGE)
    .max(100, MAX_CHARACTERS_MESSAGE)
    .matches(passwordRegex, INCORRECT_PASSWORD_MESSAGE);
var validation = {};

export { addressRegex, validation as default, nameRegex, password, passwordRegex };
//# sourceMappingURL=validation.js.map
